import { H2 } from 'foundations-components/transitional/components/H2';
import styled, { getSectionBackgroundStyle, theme } from 'academy-common-lib/utils/Styling';
import PublicCurriculumCard from './PublicCurriculumCard';
import UIList from 'UIComponents/list/UIList';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Schema from '../../publicSeo/components/Schema';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CurriculumSection = styled.section.withConfig({
  displayName: "PublicPageCurriculumSection__CurriculumSection",
  componentId: "sc-1ayahlp-0"
})(["min-height:400px;color:", ";padding:12px 0;", ""], theme.colors.OLAF, getSectionBackgroundStyle(theme.colors.OBSIDIAN));
const PublicPageCurriculumSection = ({
  items
}) => {
  return /*#__PURE__*/_jsxs(CurriculumSection, {
    className: "p-y-8",
    children: [/*#__PURE__*/_jsx(Schema, {
      object: {
        ['@type']: 'ItemList',
        itemListElement: items.filter(item => item.landingPageUrl).map((item, index) => {
          return {
            ['@type']: 'ListItem',
            position: index + 1,
            url: item.landingPageUrl
          };
        })
      }
    }), /*#__PURE__*/_jsx(H2, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyPublic.curriculum.curriculum"
      })
    }), /*#__PURE__*/_jsx(UIList, {
      childClassName: "m-bottom-6",
      lastChildClassName: "m-bottom-0",
      styled: false,
      children: items.map(item => {
        return /*#__PURE__*/_jsx(PublicCurriculumCard, {
          contentTypeName: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.contentCard.lessonType"
          }),
          description: item.description,
          duration: item.duration,
          href: item.href || '',
          id: item.id,
          instructorName: item.instructorName,
          landingPagePath: item.landingPagePath,
          thumbnailUrl: item.thumbnailUrl,
          title: item.name
        }, item.id);
      })
    })]
  });
};
export default PublicPageCurriculumSection;